import { useState, useEffect } from "react";
import { connection } from "@/lib/api";
import { WifiOff, Wifi } from "lucide-react";

export default function ConnectionBanner() {
  const [online, setOnline] = useState(connection.online);
  const [showBack, setShowBack] = useState(false);

  useEffect(() => {
    let t;
    const l = (on) => {
      setOnline(on);
      if (on) {
        setShowBack(true);
        t = setTimeout(() => setShowBack(false), 2500);
      }
    };
    connection.listeners.add(l);
    return () => { connection.listeners.delete(l); clearTimeout(t); };
  }, []);

  if (online && !showBack) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] animate-slide-up" data-testid="connection-banner" role="status">
      {online ? (
        <div className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#39FF14]/15 border border-[#39FF14]/40 backdrop-blur-xl font-mono text-sm text-[#39FF14]" data-testid="connection-restored">
          <Wifi className="w-4 h-4" /> Back online!
        </div>
      ) : (
        <div className="flex items-center gap-3 px-5 py-2.5 rounded-full bg-black/80 border border-[#FFE600]/40 backdrop-blur-xl font-mono text-sm text-[#FFE600] shadow-[0_0_24px_rgba(255,230,0,0.15)]" data-testid="connection-lost">
          <WifiOff className="w-4 h-4 animate-pulse" />
          <span>Reconnecting... your progress is safe</span>
          <span className="w-3.5 h-3.5 rounded-full border-2 border-[#FFE600]/30 border-t-[#FFE600] animate-spin" />
        </div>
      )}
    </div>
  );
}
